export type Review = {
  name: string;
  text: string;
  /** 1–5 */
  rating: number;
  /** ISO date, e.g. "2026-10-20" */
  date: string;
};

/** Only real Google reviews may be added here. Empty → the reviews section is hidden. */
export const REVIEWS: Review[] = [];

/** Google review link. Replace with the direct "write a review" link from the Google Business Profile. */
export const GOOGLE_REVIEW_URL =
  "https://www.google.com/maps/search/?api=1&query=LAKROSZ+Aut%C3%B3szerviz+V%C3%A9cseyv%C3%B6lgy+utca+99+Eger";
